// extracted by mini-css-extract-plugin
module.exports = {"fade-in":"fade-in-pFkt_","toasts-container":"toasts-container-oKECy","router":"router-_65XU","error-container":"error-container-VZXwH","loader-container":"loader-container-vwvnb"};